import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fullUpdate, updatePages } from '@store/slice/cmsSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListPages = () => {
  const { pages } = useSelector(state => state.cms)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const deleteButton = useDeleteButton()

  const toggleDynamicForm = useDynamicForm()
  const [t] = useTranslation('common')

  const dataPages = { nodes: [] }
  if (pages) {
    dataPages.nodes = Object.values(pages)
  }

  const removePage = id => {
    get(`${import.meta.env.VITE_API_URL}/api/pages/remove/${id}?mission=${mission.id}`, response => {
      const { code } = response
      if (code == 200) {
        const page = pages[id]
        const pagesList = { ...pages }
        delete pagesList[id]
        dispatch(updatePages({ ...pagesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: page.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/pages?mission=${mission.id}`, response => {
      const { code, pages, pageTypes } = response
      if (code === 200) {
        dispatch(fullUpdate({ pages, pageTypes }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('page'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.pages_list')}</h2>
      {null !== pages && dataPages.nodes.length
        ? <>
          <Table data={dataPages} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>{t('table.Title')}</HeaderCell>
                    <HeaderCell>{t('table.Type')}</HeaderCell>
                    <HeaderCell>{t('table.Language')}</HeaderCell>
                    <HeaderCell>{t('table.UpdatedAt')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.title}</Cell>
                      <Cell>{t(`content.${item.pageType}`)}</Cell>
                      <Cell>{item.language}</Cell>
                      <Cell>{item.updatedAt}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('page', null, item)
                          }
                        ]} />
                        {deleteButton(item.id, item.missionResponsibleFullName, removePage)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListPages